import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/audio/result-list.ogg'
import _imports_1 from '@/assets/images/star.svg'


const _withScopeId = n => (_pushScopeId("data-v-93a13a94"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("audio", { autoplay: "" }, [
  /*#__PURE__*/_createElementVNode("source", { src: _imports_0 })
], -1))
const _hoisted_2 = { class: "win" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  viewBox: "0 0 302.22 1333.94",
  height: "0",
  width: "0"
}, [
  /*#__PURE__*/_createElementVNode("clipPath", {
    id: "wishframe",
    transform: "scale(0.003308 0.00074965)",
    clipPathUnits: "objectBoundingBox"
  }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M0.01 168.12l0 -9.64c4.32,-21.34 12,-32.33 25.46,-25.58 -2.35,-10.3 -1.53,-26.06 5.79,-25.96 19.18,0.25 29.95,-3.14 40.24,-13.16 -4.5,-66.43 51.39,-54.26 79.61,-93.78l0 0c28.22,39.52 84.1,27.34 79.61,93.78 10.29,10.02 21.06,13.41 40.24,13.16 7.32,-0.1 8.13,15.66 5.79,25.96 13.46,-6.75 21.14,4.24 25.46,25.58l0 9.64 0.01 0 0 1004.21 -0.01 0 0 3.13c-4.32,21.34 -12,32.33 -25.46,25.58 2.35,10.3 1.53,26.06 -5.79,25.96 -19.18,-0.25 -29.95,3.14 -40.24,13.16 4.5,66.43 -51.39,54.26 -79.61,93.78l0 0c-28.22,-39.52 -84.1,-27.34 -79.61,-93.78 -10.29,-10.02 -21.06,-13.41 -40.24,-13.16 -7.32,0.1 -8.13,-15.66 -5.79,-25.96 -13.46,6.75 -21.14,-4.24 -25.46,-25.58l0 -3.13 -0.01 0 0 -1004.21 0.01 0z" })
  ])
], -1))
const _hoisted_4 = { style: {"display":"flex","justify-content":"flex-end","padding":"1rem","width":"100%","z-index":"2"} }
const _hoisted_5 = { class: "align-wishes" }
const _hoisted_6 = { class: "asset-box-border" }
const _hoisted_7 = { class: "asset-box" }
const _hoisted_8 = { class: "detail-box" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_10 = { class: "metadata-box" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "star-box" }
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_close_button = _resolveComponent("close-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_close_button, { onClicked: _ctx.exit }, null, 8, ["onClicked"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedLastRoll, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "asset-box-holder",
            style: _normalizeStyle({
          '--ani-delay': `${index * 0.1}s`,
          '--border-color': _ctx.glowStyles[item.rarity].outline,
          '--glow-color': _ctx.glowStyles[item.rarity].glow,
        })
          }, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("img", {
                      src: 
                    require(`@/assets/images/icons/icon-element-${item.element}.webp`)
                  ,
                      class: _normalizeClass({ weapon: item.type === 'Weapon', element: true })
                    }, null, 10, _hoisted_11),
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.rarity, (n) => {
                        return (_openBlock(), _createElementBlock("img", {
                          key: n,
                          src: _imports_1
                        }))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("img", {
                  class: _normalizeClass(['drop-img', { weapon: item.type === 'Weapon' }]),
                  src: require(`@/assets/images/drops/${item.id}.webp`),
                  style: _normalizeStyle({
                //@ts-ignore
                '--x': `${_ctx.ItemTransforms[item.id]?.x ?? 0}%`,
                '--y': `${_ctx.ItemTransforms[item.id]?.y ?? 0}%`,
                '--scale': `${_ctx.ItemTransforms[item.id]?.scale ?? 100}%`,
              })
                }, null, 14, _hoisted_13)
              ])
            ])
          ], 4))
        }), 128))
      ])
    ])
  ], 64))
}